export enum AddVatTuItemsFor {
  ADD_VAT_TU_DINH_MUC_CO_DINH = 'ADD_VAT_TU_DINH_MUC_CO_DINH',
  DINH_MUC = 'DINH_MUC',
  HOP_DONG = 'HOP_DONG',
  PHIEU_NHAP_LE = 'PHIEU_NHAP_LE',
  PHIEU_NHAP_KHO_KHAC = 'PHIEU_NHAP_KHO_KHAC',
  PHIEU_XUAT_KHO = 'PHIEU_XUAT_KHO',
  PHIEU_XUAT_KHO_VAT_TU_THU_HOI = 'PHIEU_XUAT_KHO_VAT_TU_THU_HOI',
  KHO = 'KHO',
}
